<mat-card>
  <ngx-spinner [zIndex]="100" name="spHistorial" bdColor="rgba(255,255,255,0.8)" size="default" color="#009688" type="ball-atom"
    [fullScreen]="false">
  </ngx-spinner>

  <!-- Buscador general -->
  <div class="row" [hidden]="!data">
    <div class="col-lg-3">
      <mat-form-field class="full-width">
        <mat-label>Buscar en tabla</mat-label>
        <input type="search" matInput (keyup)="applyFilter($event)">
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>
    </div>
  </div>

  <!-- Tabla -->
  <table mat-table [dataSource]="dataSource" matSort [hidden]="!data" class="mat-elevation-z8">


    <!-- Columna Propiedad -->
    <ng-container matColumnDef="propiedad">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Propiedad</th>
      <td mat-cell *matCellDef="let element">
        <div>
          <strong>{{element.propiedad?.ubicacion}}</strong>
          <br>
          <small class="text-muted">{{element.propiedad?.localidad?.descripcion}}</small>
        </div>
      </td>
    </ng-container>

    <!-- Columna Propietario Anterior -->
    <ng-container matColumnDef="propietarioAnterior">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Propietario Anterior</th>
      <td mat-cell *matCellDef="let element">
        <div>
          <mat-icon class="small-icon">person_outline</mat-icon>
          {{element.propietarioAnterior?.persona?.descripcion}}
        </div>
      </td>
    </ng-container>

    <!-- Columna Propietario Nuevo -->
    <ng-container matColumnDef="propietarioNuevo">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Propietario Nuevo</th>
      <td mat-cell *matCellDef="let element">
        <div>
          <mat-icon class="small-icon text-success">person</mat-icon>
          {{element.propietarioNuevo?.persona?.descripcion}}
        </div>
      </td>
    </ng-container>

    <!-- Columna Fecha Cambio -->
    <ng-container matColumnDef="fechaCambio">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Fecha Cambio</th>
      <td mat-cell *matCellDef="let element">
        {{element.fechaCambio | date:'dd/MM/yyyy'}}
      </td>
    </ng-container>

    <!-- Columna Motivo -->
    <ng-container matColumnDef="motivo">
      <th mat-header-cell *matHeaderCellDef>Motivo</th>
      <td mat-cell *matCellDef="let element">
        <span class="motivo-text">{{element.motivo}}</span>
      </td>
    </ng-container>

    <!-- Columna Movimientos Afectados -->
    <ng-container matColumnDef="cantidadMovimientos">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Movimientos</th>
      <td mat-cell *matCellDef="let element">
        <mat-chip-list>
          <mat-chip [color]="element.cantidadMovimientosAfectados > 0 ? 'warn' : 'primary'" selected>
            {{element.cantidadMovimientosAfectados}}
          </mat-chip>
        </mat-chip-list>
      </td>
    </ng-container>

    <!-- Columna Acciones -->
    <!-- <ng-container matColumnDef="accion">
      <th mat-header-cell *matHeaderCellDef>Acciones</th>
      <td mat-cell *matCellDef="let element" class="action-link">
        <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Menú de acciones">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="openDialog('Ver', element)">
            <mat-icon>visibility</mat-icon>
            <span>Ver Detalle</span>
          </button>
          <button mat-menu-item (click)="verMovimientosAfectados(element)">
            <mat-icon>list</mat-icon>
            <span>Ver Movimientos</span>
          </button>
        </mat-menu>
      </td>
    </ng-container> -->

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <!-- Sin datos -->
  <app-sin-datos *ngIf="dataSource.data.length == 0" mensaje="No se encontraron registros de cambios de propietarios"></app-sin-datos>

  <!-- Paginador -->
  <mat-paginator
    showFirstLastButtons
    class="paginator"
    [hidden]="!data"
    [pageSize]="20"
    [pageSizeOptions]="[10, 20, 50, 100]">
  </mat-paginator>
</mat-card>
